<template>
  <video
    ref="videoPlayer"
    :poster="poster"
    class="video-js h-full object-cover rounded-lg duration-300"
    :class="[isModal ? 'm-auto w-auto align-center' : 'w-full mx-auto']"
    controlslist="nofullscreen nodownload noremoteplayback noplaybackrate"
    loop
    muted
    autoplay
    playsinline
  />
</template>
<script lang="ts" setup>
import Hls from 'hls.js'

const { source = '', sourceStream = '', poster = '', isModal = false } =
  defineProps<{
    source: string
    sourceStream?: string
    poster: string
    isModal?: boolean
  }>()

const videoPlayer = ref(null) // ref to video element on page
const hlsRef = ref(null) // ref to hls instance

// trying to load stream video
const loadVideo = (playerRefValue) => {
  if (hlsRef.value || !playerRefValue) return

  if (!Hls.isSupported()) {
    // Fallback for old browsers
    return loadLegacyVideo(playerRefValue)
  }

  const hls = new Hls() // run hls.js
  hls.loadSource(sourceStream) // load source
  hls.attachMedia(playerRefValue) // attach it to player

  hls.on(Hls.Events.ERROR, function (event, data) {
    if (data.fatal) {
      hls.destroy()
      loadLegacyVideo(playerRefValue)
    }
  })

  hlsRef.value = hls // store hls instance
}

const loadLegacyVideo = (playerRefValue) => {
  if (!playerRefValue) return
  playerRefValue.src = source
}

onMounted(() => {
  // check if hls instance is already created
  if (!hlsRef?.value) {
    loadVideo(videoPlayer.value)
  }
})

onUnmounted(() => {
  // destroy hls instance
  if (hlsRef?.value) {
    hlsRef.value.destroy()
    hlsRef.value = null
  }
})
</script>
